<template>
  <div class="navbar" :style="{ backgroundColor: backgroundColor }">
    <div v-if="showNavbar">
       <van-nav-bar
      :title="title"
      ref="navbar"
      placeholder
      fixed
      :border="false"
      safe-area-inset-top
      z-index="999"
    >
      <template #left>
        <slot name="left"></slot>
        <div v-if="showLeft" class="left-wrap">
          <img
            v-if="!leftArrow"
            @click="goBack"
            class="leftIcon"
            src="@/assets/style/load-left-icon.png"
            alt=""
          />
          <img
            v-if="leftArrow"
            @click="goBack"
            class="leftIcon"
            src="@/assets/style/left-icon.png"
            alt=""
          />
        </div>
      </template>
      <template #right>
        <slot name="right"></slot>
        <div class="right-icons">
          <img
            @click="handleClickNotify"
            v-if="isNotify"
            class="notifyIcon"
            src="@/assets/style/my-notify-icon.png"
            alt=""
          />
          <img
            @click="qimoChatClick"
            v-if="isCustomerService"
            class="customerServiceIcon"
            src="@/assets/style/my-customer-service-icon.png"
            alt=""
          />
        </div>
      </template>
    </van-nav-bar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    title: {
      type: String,
      default: "",
    },
    leftArrow: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    isRight: {
      type: Boolean,
      default: true,
    },
    isNotify: {
      type: Boolean,
      default: false,
    },
    isCustomerService: {
      type: Boolean,
      default: true,
    },
    showLeft: {
      type: Boolean,
      default: true,
    },
    //特殊处理返回逻辑
    isSpecialBack: {
      type: Boolean,
      default: false,
    },
    //监听物理键返回事件
    isHandleBack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNavbar: true,
    };
  },
  methods: {
    goBack() {
      if (this.isSpecialBack) {
        this.$emit("goBack");
      } else {
        this.$router.back();
      }
    },
    qimoChatClick() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        const nickName = this.userInfo?.username || "";
        const clientId = `phone_${localStorage.getItem("phone") || ""}`;
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN&nickName=${nickName}&clientId=${clientId}`,
        );
      }
    },
    handleClickNotify() {
      this.$router.push({ name: "notify" });
    },
  },
  mounted() {
    console.log(this.$refs.navbar,"refs.navbar");
  },
  computed: {
  userInfo(){
    return this.$store.state.userInfo;
  },
  navRefsDom() {
    return this.$refs.navbar;
  },
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    this.showNavbar = false;
  },
  destroyed() {
    console.log("destroyed");
    this.showNavbar = false;
  },

};
</script>

<style scoped lang="scss">
.right-icons {
  display: flex;
}
.notifyIcon {
  width: 24px;
  height: 24px;
}
.customerServiceIcon {
  width: 24px;
  height: 24px;
  padding-left: 16px;
}
.leftIcon {
  height: 24px;
  width: 24px;
}
::v-deep(.van-nav-bar__title) {
  font-size: 18px;
  font-weight: bold;
}
.left-wrap {
  display: flex;
  align-items: center;
}
::v-deep(.van-nav-bar__content) {
  height: 56px !important;
}
</style>
